import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { lancasterConfig } from "./data";

export default function LancasterPage() {
  return <CityPageTemplate config={lancasterConfig} />;
}